import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";
import { COLORS } from "../../shared";

export const AsyncSearchStyled = styled.div`
  width: 200px;
  margin-left: 20px;

  .async-option {
    font-size: 14px;
    line-height: 1.5;
    min-height: 40px;
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 10px;
    box-sizing: border-box;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
    &__wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
    &__right {
      width: calc(100% - 55px);
    }
    &__image {
      width: 50px;
      height: 50px;
      border-radius: 5px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &:hover {
      background-color: rgba(38, 132, 255, 0.08);
    }
    span {
      display: block;
      width: 100%;
      &:first-child {
        font-size: 14px;
        width: 100%;
      }
      &:last-child {
        font-size: 12px;
        display: inline-block;
        padding: 2px 5px;
        margin-top: 5px;
        width: auto;
        border-radius: 3px;
        background-color: ${COLORS.GRAY};
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    width: 150px;
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    width: 160px;
    font-size: 14px;
  }
`;
